import { getToken, getUser } from "../../Utilities/Common"
import { getWithParamsAPICall, postAPICallwithFile, postQrAPICall } from "../axiosMethodCall"

export const createQueue = async (params) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", params.patient_id)
    formData.append("status", params.status || "")
    formData.append("doctor_id", params.doctor_id || "")
    formData.append("complaint", params.complaint || "")

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "queues/create",
      formData
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createCSRQueue = async (params) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("master_patient_id", params.master_patient_id)
    formData.append("transaction_type", params.transaction_type)

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "queues/queue_csr",
      formData
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const updateQueue = async (params) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("queue_id", params.queue_id)
    formData.append("patient_id", params.patient_id)
    formData.append("status", params.status || "")
    formData.append("doctor_id", params.doctor_id || "")
    formData.append("complaint", params.complaint || "")

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "queues/update",
      formData
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const removePatientFromQueue = async (patient_id) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id)

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "queues/end_patient_queue",
      formData
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getQueuedPatients = async (params) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "queues/get",
      {
        requester: getUser(),
        token: getToken(),
        ...params,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const setFPEDone = async (params) => {
  try {
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patients/set_fpe_done",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: params.patient_id,
        action: params.action || "skip",
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const endCurrentQueue = async (params) => {
  try {
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "queues/end_queue",
      {
        requester: getUser(),
        token: getToken(),
        queue_id: params.queue_id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const endQueue = async (params) => {
  return endCurrentQueue(params)
}

export const createBookings = async (params) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("queue_id", params.queue_id || "")
    formData.append("patient_id", params.patient_id)
    formData.append("type", params.type || "walk in")
    formData.append("status", params.status || "pending")
    formData.append("transaction_type", "consultation")
    formData.append("assessment_type", "ekonsulta")
    formData.append("doctor_id", params.doctor_id || "")
    formData.append("master_doctor_id", params.master_doctor_id || "")
    formData.append("doctor_name", params.doctor_name || "")
    formData.append("total_amount", params.total_amount || "0")
    formData.append("origin", "emr")

    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "bookings/create",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

